export const OrgAdminConstants = {
    REQUEST_TEAM_CSV_UPLOAD: 'REQUEST_TEAM_CSV_UPLOAD',
    RECEIVE_TEAM_CSV_UPLOAD: 'RECEIVE_TEAM_CSV_UPLOAD',
    ERROR_TEAM_CSV_UPLOAD: 'ERROR_TEAM_CSV_UPLOAD',

    REQUEST_ORG_TEAM: 'REQUEST_ORG_TEAM',
    RECEIVE_ORG_TEAM: 'RECEIVE_ORG_TEAM',
    ORG_TEAM_ERROR: 'ORG_TEAM_ERROR',

    REQUEST_ADD_ORG_TEAM: 'REQUEST_ADD_ORG_TEAM',
    RECEIVE_ADD_ORG_TEAM: 'RECEIVE_ADD_ORG_TEAM',
    ADD_ORG_TEAM_ERROR: 'ADD_ORG_TEAM_ERROR',

    REQUEST_EDIT_ORG_TEAM: 'REQUEST_EDIT_ORG_TEAM',
    RECEIVE_EDIT_ORG_TEAM: 'RECEIVE_EDIT_ORG_TEAM',
    EDIT_ORG_TEAM_ERROR: 'EDIT_ORG_TEAM_ERROR',

    REQUEST_REMOVE_ORG_TEAM: 'REQUEST_REMOVE_ORG_TEAM',
    RECEIVE_REMOVE_ORG_TEAM: 'RECEIVE_REMOVE_ORG_TEAM',
    REMOVE_ORG_TEAM_ERROR: 'REMOVE_ORG_TEAM_ERROR',

    REQUEST_MEMBER_LEVEL: 'REQUEST_MEMBER_LEVEL',
    RECEIVE_MEMBER_LEVEL: 'RECEIVE_MEMBER_LEVEL',
    MEMBER_LEVEL_ERROR: 'MEMBER_LEVEL_ERROR',

    REQUEST_CHANGE_MEMBER_LEVEL: 'REQUEST_CHANGE_MEMBER_LEVEL',
    RECEIVE_CHANGE_MEMBER_LEVEL: 'RECEIVE_CHANGE_MEMBER_LEVEL',
    CHANGE_MEMBER_LEVEL_ERROR: 'CHANGE_MEMBER_LEVEL_ERROR',

    REQUEST_TEAM_MEMBERS_LIST: 'REQUEST_TEAM_MEMBERS_LIST',
    RECEIVE_TEAM_MEMBERS_LIST: 'RECEIVE_TEAM_MEMBERS_LIST',
    TEAM_MEMBERS_LIST_ERROR: 'TEAM_MEMBERS_LIST_ERROR',

    REQUEST_MOVE_TO_DIFFERENT_TEAM: 'REQUEST_MOVE_TO_DIFFERENT_TEAM',
    RECEIVE_MOVE_TO_DIFFERENT_TEAM: 'RECEIVE_MOVE_TO_DIFFERENT_TEAM',
    MOVE_TO_DIFFERENT_TEAM_ERROR: 'MOVE_TO_DIFFERENT_TEAM_ERROR',

    REQUEST_RESET_TEAM_LEADER: 'REQUEST_RESET_TEAM_LEADER',
    RECEIVE_RESET_TEAM_LEADER: 'RECEIVE_RESET_TEAM_LEADER',
    RESET_TEAM_LEADER_ERROR: 'RESET_TEAM_LEADER_ERROR',

    REQUEST_MAKE_TEAM_LEADER: 'REQUEST_MAKE_TEAM_LEADER',
    RECEIVE_MAKE_TEAM_LEADER: 'RECEIVE_MAKE_TEAM_LEADER',
    MAKE_TEAM_LEADER_ERROR: 'MAKE_TEAM_LEADER_ERROR',

    REQUEST_ORG_USERS: 'REQUEST_ORG_USERS',
    RECEIVE_ORG_USERS: 'RECEIVE_ORG_USERS',
    ORG_USERS_ERROR: 'ORG_USERS_ERROR',

    REQUEST_ADD_PA_USERS: 'REQUEST_ADD_PA_USERS',
    RECEIVE_ADD_PA_USERS: 'RECEIVE_ADD_PA_USERS',
    ADD_PA_USERS_ERROR: 'ADD_PA_USERS_ERROR',

    REQUEST_REMOVE_PA_USERS: 'REQUEST_REMOVE_PA_USERS',
    RECEIVE_REMOVE_PA_USERS: 'RECEIVE_REMOVE_PA_USERS',
    REMOVE_PA_USERS_ERROR: 'REMOVE_PA_USERS_ERROR',

    REQUEST_PA_USER_PERMISSIONS_LIST:'REQUEST_PA_USER_PERMISSIONS_LIST',
    RECEIVE_PA_USER_PERMISSIONS_LIST:'RECEIVE_PA_USER_PERMISSIONS_LIST',
    PA_USER_PERMISSIONS_LIST_ERROR:'PA_USER_PERMISSIONS_LIST_ERROR',

    REQUEST_CHANGE_ACCESS: 'REQUEST_CHANGE_ACCESS',
    RECEIVE_CHANGE_ACCESS: 'RECEIVE_CHANGE_ACCESS',
    CHANGE_ACCESS_ERROR: 'CHANGE_ACCESS_ERROR',

    REQUEST_MASTER_MODULE_LIST:'REQUEST_MASTER_MODULE_LIST',
    RECEIVE_MASTER_MODULE_LIST:'RECEIVE_MASTER_MODULE_LIST',
    MASTER_MODULE_LIST_ERROR:'MASTER_MODULE_LIST_ERROR',

    REQUEST_MODULE_PERMISSIONS_LIST:'REQUEST_MODULE_PERMISSIONS_LIST',
    RECEIVE_MODULE_PERMISSIONS_LIST:'RECEIVE_MODULE_PERMISSIONS_LIST',
    MODULE_PERMISSIONS_LIST_ERROR:'MODULE_PERMISSIONS_LIST_ERROR',

    REQUEST_MODULE_CHANGE_ACCESS:'REQUEST_MODULE_CHANGE_ACCESS',
    RECEIVE_MODULE_CHANGE_ACCESS:'RECEIVE_MODULE_CHANGE_ACCESS',
    MODULE_CHANGE_ACCESS_ERROR:'MODULE_CHANGE_ACCESS_ERROR',

    REQUEST_TOGGLE_ANALYSIS: 'REQUEST_TOGGLE_ANALYSIS',
    RECEIVE_TOGGLE_ANALYSIS: 'RECEIVE_TOGGLE_ANALYSIS',
    TOGGLE_ANALYSIS_ERROR: 'TOGGLE_ANALYSIS_ERROR',

}


// WEBPACK FOOTER //
// ./src/_constants/OrgAdmin/orgAdmin.constants.js